/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Deals_Showing_OfInputs */

const cs_deals_showing_of = /** @type {(inputs: Deals_Showing_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zobrazeno ${i?.shown} z ${i?.total}`)
};

const en_deals_showing_of = /** @type {(inputs: Deals_Showing_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Showing {shown} of {total}" |
*
* @param {Deals_Showing_OfInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_showing_of = /** @type {((inputs: Deals_Showing_OfInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Showing_OfInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_showing_of(inputs)
	return cs_deals_showing_of(inputs)
});